import { css } from 'styled-components';

export default css`
  background-color: var(--color-background-header);
  width: 100%;
  padding-left: 20px;
`;
